export default {
	updateConnectInvoices(state, res) {
		if (res.Data) {
			state.ConnectInvoices = [...res.Data];
			state.ConnectInvoicesTotal = res.Total;
		} else {
			state.ConnectInvoices = [];
			state.ConnectInvoicesTotal = 0;
		}
	},
	updateMisaIdInfo(state, res) {
		state.MisaIdInfo = res;
	}
};
